import React, { useEffect, useState } from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import useDocDownload from "../app/hooks/useDocDownload";
import { deleteReceivedDocument, getDocuments, getEsignDocuments, getReceivedDocDeleteStatus, getReqDocuments, getSignedDocumentData, loadDocuments, loadEsignDocuments, loadReqDocuments, loadSignedDocument, receviedDocDeleted, signedDocumentReceived, updateReceivedDocStatus } from "../app/store/documents";
import { getPurchaseOrderDoc, getPurchaseOrders, loadPurchaseOrderDoc, loadPurchaseOrders, purchaseOrderDocReceived } from "../app/store/purchaseOrder";
import { getAlert, getConfirmAlert, getConfirmAlertWithAuth } from "../services/appAlerts";
import moment from "moment";

const ReceivedDocuments = ({
    item, workflowTask
}) => {

    const [pOrders, setPOrders] = useState([]);
    const [reqDocs, setReqDocs] = useState([]);
    const [appDocuments, setAppDocuments] = useState([]);
    const [esignDocs, setEsignDocs] = useState([]);
    const [selectedSignedDoc, setSelectedSignedDoc] = useState(null);
    const [signLoading, setSignLoading] = useState(false);
    const [deleteType, setDeleteType] = useState("");
    const [esignLinkCache, setEsignLinkCache] = useState({});
    const [esignLinkLoadingKey, setEsignLinkLoadingKey] = useState(null);

    const documentsSelector = useSelector(getDocuments);
    const purchaseOrdersSelector = useSelector(getPurchaseOrders);
    const reqDocumentsSelector = useSelector(getReqDocuments);
    const purchaseOrderDocSelector = useSelector(getPurchaseOrderDoc);
    const esignDocumentsSelector = useSelector(getEsignDocuments);
    const signedDocumentDataSelector = useSelector(getSignedDocumentData);
    const receivedDocDeleteStatusSelector = useSelector(getReceivedDocDeleteStatus);

    const [handleDownloadFile] = useDocDownload();
    const dispatch = useDispatch();

    const getWorkbenchApiBaseUrl = () => (process?.env?.REACT_APP_API_BASEURL || "").replace(/\/$/, "");

    const getEsignApiBaseUrl = () =>
        process?.env?.REACT_APP_ESIGN_API_BASEURL ||
        process?.env?.REACT_APP_ESIGN_API_URL ||
        (window.location.hostname === "localhost" ? "http://localhost:5005" : "");

    const getReceivedEsignDocumentId = (doc) =>
        doc?.documentId || doc?.DocumentId || doc?.sourceDocumentId || doc?.docId;

    const getReceivedEsignToken = (doc) =>
        doc?.evelopId || doc?.EvelopId || doc?.preparationToken;

    const resolveReceivedEsignLinks = async (doc) => {
        const sourceDocumentId = getReceivedEsignDocumentId(doc);
        const cacheKey = sourceDocumentId || doc?.id;

        if (cacheKey && esignLinkCache[cacheKey]) {
            return esignLinkCache[cacheKey];
        }

        if (sourceDocumentId) {
            const response = await fetch(`${getWorkbenchApiBaseUrl()}/api/ReviewForm/GetDocumentESignLinks?docId=${sourceDocumentId}`);
            const data = await response.json().catch(() => null);

            if (response.ok && data) {
                setEsignLinkCache((current) => ({ ...current, [cacheKey]: data }));
                return data;
            }
        }

        const token = getReceivedEsignToken(doc);
        const apiBaseUrl = getEsignApiBaseUrl();
        if (token && apiBaseUrl) {
            const links = {
                visibleSigned: `${apiBaseUrl.replace(/\/$/, "")}/api/public/documents/${token}/download/visible-signed?inline=true`,
                finalSigned: `${apiBaseUrl.replace(/\/$/, "")}/api/public/documents/${token}/download/final-signed?inline=true`
            };
            if (cacheKey) {
                setEsignLinkCache((current) => ({ ...current, [cacheKey]: links }));
            }
            return links;
        }

        return null;
    };

    const handleOpenReceivedEsignDocument = async (doc, linkType) => {
        const loadingKey = `${doc.id}-${linkType}`;

        try {
            setEsignLinkLoadingKey(loadingKey);
            const links = await resolveReceivedEsignLinks(doc);
            const url = links?.[linkType];

            if (url) {
                window.open(url, "_blank");
                return;
            }

            if (linkType === "finalSigned") {
                handleDownloadEsignedFile(doc, "1");
                return;
            }

            getAlert("", "Signed document link is not available.", "error");
        } catch (error) {
            getAlert("", "Unable to open signed document. Please try again.", "error");
        } finally {
            setEsignLinkLoadingKey(null);
        }
    };

    useEffect(() => {

    }, [])

    useEffect(() => {
        if (workflowTask) {
            setReqDocs([]);
            setPOrders([]);
            setAppDocuments([]);
            setEsignDocs([]);
            dispatch(loadDocuments(workflowTask.ciid));
            dispatch(loadReqDocuments(workflowTask.ciid));
            dispatch(loadPurchaseOrders(item.id));
            dispatch(loadEsignDocuments(item?.id));
        }
    }, [workflowTask])

    useEffect(() => {
        setEsignDocs(esignDocumentsSelector);
    }, [esignDocumentsSelector])

    useEffect(() => {
        setPOrders(purchaseOrdersSelector);
    }, [purchaseOrdersSelector]);

    useEffect(() => {
        setReqDocs(reqDocumentsSelector);
    }, [reqDocumentsSelector])

    useEffect(() => {
        setAppDocuments(documentsSelector);
    }, [documentsSelector]);

    const handleDocStatusChange = (docId, status, type) => {
        dispatch(updateReceivedDocStatus(docId, status, type));
    }

    const handleDeleteFile = async (docId, type) => {
        const confirmDelete = await getConfirmAlertWithAuth(
            "",
            "Are you sure you want to delete this document?",
            "warning"
        );

        if (confirmDelete.isConfirmed) {
            dispatch(deleteReceivedDocument(docId, type));
            setDeleteType(type);
        }
    };

    useEffect(() => {
        if (receivedDocDeleteStatusSelector) {
            getAlert("", "Document deleted successfully", "success");
            setDeleteType("");
            dispatch(receviedDocDeleted(null));
            // Refresh document lists after deletion
            if (deleteType === "doc") {
                dispatch(loadDocuments(workflowTask.ciid));
            } else if (deleteType === "req") {
                dispatch(loadReqDocuments(workflowTask.ciid));
            } else if (deleteType === "po") {
                dispatch(loadPurchaseOrders(item.id));
            } else if (deleteType === "esign") {
                dispatch(loadEsignDocuments(item?.id));
            }
        }
    }, [receivedDocDeleteStatusSelector]);

    const getReqRefDocs = (item) => {
        if (item.refDocId > 0) {
            const findDocs = appDocuments.filter(x => x.uploadId === item.refDocId && x.deleteFlag !== true);
            if (findDocs.length > 0) {
                return <>
                    {findDocs.map(doc =>
                        <div className="rt-rd-doc-info" key={doc.docId}>
                            <div className="rt-rd-file-icon is-req">
                                <i className="fa fa-folder-open-o" aria-hidden="true" />
                            </div>
                            <div className="rt-rd-card-title-area">
                                <span style={{ fontWeight: "700", color: "#0f172a", fontSize: "13.5px" }}>{item.documnetName}</span>
                                <div style={{ marginTop: "2px" }}>
                                    {getReqUploadedDocs(item, "req")}
                                </div>
                            </div>
                        </div>
                    )}
                </>
            }
        }

        return (
            <div className="rt-rd-doc-info">
                <div className="rt-rd-file-icon is-req">
                    <i className="fa fa-folder-open-o" aria-hidden="true" />
                </div>
                <div className="rt-rd-card-title-area">
                    <span style={{ fontWeight: "700", color: "#0f172a", fontSize: "13.5px" }}>{item.documnetName}</span>
                    <div style={{ marginTop: "2px" }}>
                        {getReqUploadedDocs(item, "req")}
                    </div>
                </div>
            </div>
        );
    }

    const getReqUploadedDocs = (item, type) => {
        const achDocs = appDocuments.filter(
            (x) => x.updType === `req_${!item.id ? item.docId : item.id}` && x.deleteFlag !== true
        );

        if (achDocs.length > 0) {
            const doc = achDocs[0];
            return <>
                <button
                    className="btn btn-link btn-sm p-0"
                    title="Download Document"
                    onClick={() => handleDownloadFile(doc)}
                    style={{ fontSize: "11px", fontWeight: "700" }}
                >
                    <i className="fa fa-download mr-1" aria-hidden="true" />
                    {doc.docName}
                </button>
            </>
        }

        return <span className="text-muted" style={{ fontSize: "11px" }}>No document uploaded</span>;
    }

    const getReqUploadedNotes = (item) => {
        const achDocs = appDocuments.filter(
            (x) => x.updType === `req_${!item.id ? item.docId : item.id}` && x.deleteFlag !== true
        );

        if (achDocs.length > 0) {
            const doc = achDocs[0];
            return doc.remarks || "";
        }

        return "";
    }

    const getReqUploadedSize = (item) => {
        const achDocs = appDocuments.filter(
            (x) => x.updType === `req_${!item.id ? item.docId : item.id}`
        );
        if (achDocs.length > 0) {
            const doc = achDocs[0];
            return <span className="rt-rd-size-badge">{doc.docSize}</span>
        }

        return null;
    }

    const getReqDeleteAction = (item) => {
        const achDocs = appDocuments.filter(
            (x) => x.updType === `req_${!item.id ? item.docId : item.id}` && x.deleteFlag !== true
        );
        if (achDocs.length > 0) {
            const doc = achDocs[0];
            return (
                <button
                    className="rt-rd-delete-btn"
                    title="Delete File"
                    onClick={() => handleDeleteFile(doc.docId, "doc")}
                >
                    <i className="fa fa-trash"></i>
                </button>
            );
        }

        return (
            <button
                className="rt-rd-delete-btn"
                title="Delete File"
                onClick={() => handleDeleteFile(item.id, "req")}
            >
                <i className="fa fa-trash"></i>
            </button>
        );
    }

    const getReqStatusBadge = (item) => {
        const achDocs = appDocuments.filter(
            (x) => x.updType === `req_${!item.id ? item.docId : item.id}` && x.deleteFlag !== true
        );
        if (achDocs.length > 0) {
            return (
                <span className="rt-rd-status-badge is-received">
                    <i className="fa fa-arrow-down mr-1" aria-hidden="true" />
                    Received
                </span>
            );
        }

        if (item.sendStatus === true) {
            return (
                <span className="rt-rd-status-badge is-sent">
                    <i className="fa fa-arrow-up mr-1" aria-hidden="true" />
                    Sent
                </span>
            );
        }

        return (
            <span className="rt-rd-status-badge is-draft">
                <i className="fa fa-clock-o mr-1" aria-hidden="true" />
                Not Sent
            </span>
        );
    }

    const handleDownloadPoFile = async (item, type) => {
        dispatch(loadPurchaseOrderDoc(item.id, type));
    };

    useEffect(() => {
        if (purchaseOrderDocSelector?.uploadUrl === null) {
            getAlert("", "Document Not Found", "error");
            dispatch(purchaseOrderDocReceived(null));
        } else if (purchaseOrderDocSelector?.uploadUrl) {
            window.open(purchaseOrderDocSelector?.uploadUrl, "_blank");
            dispatch(purchaseOrderDocReceived(null));
        }
    }, [purchaseOrderDocSelector]);

    const handleDownloadEsignedFile = async (item, type) => {
        setSelectedSignedDoc(item);
        setSignLoading(true);
        dispatch(loadSignedDocument(item.id, type));
    }

    useEffect(() => {
        if (signedDocumentDataSelector && selectedSignedDoc) {
            window.open(signedDocumentDataSelector?.uploadUrl, "_blank");
            setSelectedSignedDoc(null);
            setSignLoading(false);
            dispatch(signedDocumentReceived(null));
        }
    }, [signedDocumentDataSelector])

    const getPopover = (notes) => {
        const popover = (
            <Popover id="popover-basic">
                <Popover.Title as="h4">Notes</Popover.Title>
                <Popover.Content>{notes}</Popover.Content>
            </Popover>
        );
        return (
            <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                <button type="button" className="rt-rd-notes-btn">
                    <i className="fa fa-sticky-note-o mr-1" /> Notes
                </button>
            </OverlayTrigger>
        );
    };

    const requiredDocumentRefIds = new Set(
        reqDocs
            .filter((doc) => doc.refDocId > 0)
            .map((doc) => String(doc.refDocId))
    );

    const isVisibleAppDocument = (doc) => (
        !requiredDocumentRefIds.has(String(doc.uploadId)) &&
        doc.uploadType !== "agency" &&
        doc.uploadType !== "msp" &&
        doc.uploadType !== "Invoice" &&
        doc.uploadType !== "client" &&
        doc.uploadType !== "project" &&
        doc.uploadType !== "ProjectInfo" &&
        doc.remarks !== "Time Sheet" &&
        doc.updType !== "Messaging" &&
        doc.updType !== "internal" &&
        doc.updType !== "Invoice" &&
        doc.uploadType !== "Messaging" &&
        doc.uploadType !== "reporting" &&
        !doc.uploadType?.includes("req_") &&
        !doc.uploadType?.includes("ach_") &&
        !doc.uploadType?.includes("insurance_") &&
        !(doc.updType && doc.updType.includes("req_")) &&
        doc.deleteFlag !== true &&
        doc.docModifiedName !== "esign"
    );

    const mergedDocs = [
        ...appDocuments
            .filter(
                (x) => isVisibleAppDocument(x)
            )
            .map((d) => ({
                ...d,
                type: "app",
                date: moment(d.dateTime)
            })),

        ...pOrders
            .filter((x) => x.sendStatus === true)
            .map((p) => ({
                ...p,
                poType: p.type,
                type: "po",
                date: moment(p.addedDateTime)
            })),

        ...reqDocs
            .filter((f) => f.deleteFlag !== true)
            .map((f) => ({
                ...f,
                type: "req",
                date: moment(f.addedDateTime)
            })),

        ...esignDocs
            .filter((f) => f.signedStatus === "1" || f.signedStatus === "Signed" || f.signedStatus === "Completed")
            .map((f) => ({
                ...f,
                type: "esign",
                date: moment(f.createdDateTime)
            }))
    ];

    const sortedDocs = mergedDocs.sort((a, b) => b.date - a.date);

    const isDocumentSent = (doc) =>
        doc?.sentStatus === true ||
        doc?.sentStatus === "true" ||
        doc?.sentStatus === 1 ||
        doc?.sentStatus === "1" ||
        !!doc?.sentDateTime;

    const renderAppDocumentStatusBadge = (doc) => {
        if (isDocumentSent(doc)) {
            return (
                <span className="rt-rd-status-badge is-sent">
                    <i className="fa fa-arrow-up mr-1" aria-hidden="true" /> Sent
                </span>
            );
        }

        return (
            <span className="rt-rd-status-badge is-draft">
                <i className="fa fa-clock-o mr-1" aria-hidden="true" /> Not Sent
            </span>
        );
    };

    const renderCard = (doc) => {
        const notesContent = doc.type === "req" ? getReqUploadedNotes(doc) : (doc.remarks || doc.notes);

        return (
            <div className="rt-rd-row">
                {/* 1. Icon */}
                {doc.type === "app" && (
                    <div className="rt-rd-file-icon is-app" title="General Document">
                        <i className="fa fa-file-text-o" aria-hidden="true" />
                    </div>
                )}
                {doc.type === "po" && (
                    <div className="rt-rd-file-icon is-po" title="PO Document">
                        <i className="fa fa-file-pdf-o" aria-hidden="true" />
                    </div>
                )}
                {doc.type === "req" && (
                    <div className="rt-rd-file-icon is-req" title="Requested Document">
                        <i className="fa fa-folder-open-o" aria-hidden="true" />
                    </div>
                )}
                {doc.type === "esign" && (
                    <div className="rt-rd-file-icon is-esign" title="E-signed Document">
                        <i className="fa fa-pencil" aria-hidden="true" />
                    </div>
                )}

                {/* 2. File Name & Details */}
                <div className="rt-rd-file-main">
                    {doc.type === "app" && (
                        <button
                            className="rt-rd-doc-name-btn"
                            title="Download File"
                            onClick={() => handleDownloadFile(doc)}
                        >
                            {doc.docName}
                        </button>
                    )}

                    {doc.type === "po" && (
                        doc.partnerSign ? (
                            <button
                                className="rt-rd-doc-name-btn"
                                onClick={() => handleDownloadPoFile(doc, "partner")}
                                title="Download PO Document"
                            >
                                {doc.ipcsPoName}
                            </button>
                        ) : (
                            <span style={{ fontWeight: "600", color: "#0f172a", fontSize: "13.5px" }}>PO Document</span>
                        )
                    )}

                    {doc.type === "req" && (() => {
                        const refDocs = doc.refDocId > 0
                            ? appDocuments.filter((x) => x.uploadId === doc.refDocId && x.deleteFlag !== true)
                            : [];

                        if (refDocs.length > 0) {
                            return (
                                <div className="rt-rd-req-doc-stack">
                                    {refDocs.map((d) => (
                                        <div key={`ref-${d.docId}`} className="rt-rd-req-doc-line">
                                            <span className="rt-rd-mini-tag">Ref</span>
                                            <button
                                                className="rt-rd-doc-name-btn rt-rd-req-doc-link"
                                                onClick={() => handleDownloadFile(d)}
                                                title="Download Reference Document"
                                            >
                                                {d.docName}
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            );
                        }

                        return (
                            <span style={{ fontWeight: "600", color: "#0f172a", fontSize: "13.5px" }}>
                                {doc.documnetName}
                            </span>
                        );
                    })()}

                    {doc.type === "esign" && (
                        <div className="rt-rd-esign-actions">
                            <button
                                className="rt-rd-doc-name-btn"
                                disabled={(signLoading && selectedSignedDoc?.id === doc.id) || esignLinkLoadingKey === `${doc.id}-finalSigned`}
                                onClick={() => handleOpenReceivedEsignDocument(doc, "finalSigned")}
                                title="Open Digital Signed Document"
                            >
                                {esignLinkLoadingKey === `${doc.id}-finalSigned` ? (
                                    <><i className="fa fa-spinner fa-spin mr-1" /> Opening...</>
                                ) : (
                                    doc.documentName
                                )}
                            </button>
                            <button
                                className="rt-rd-esign-download-btn"
                                disabled={esignLinkLoadingKey === `${doc.id}-visibleSigned`}
                                onClick={() => handleOpenReceivedEsignDocument(doc, "visibleSigned")}
                                title="Open Visible Signed Document"
                            >
                                {esignLinkLoadingKey === `${doc.id}-visibleSigned` ? (
                                    <><i className="fa fa-spinner fa-spin mr-1" /> Opening...</>
                                ) : (
                                    <><i className="fa fa-file-pdf-o mr-1" /> Visible Signed</>
                                )}
                            </button>
                            <button
                                className="rt-rd-esign-download-btn"
                                disabled={esignLinkLoadingKey === `${doc.id}-finalSigned`}
                                onClick={() => handleOpenReceivedEsignDocument(doc, "finalSigned")}
                                title="Open Digital Signed Document"
                            >
                                <i className="fa fa-certificate mr-1" /> Digital Signed
                            </button>
                        </div>
                    )}

                    <div className="rt-rd-doc-meta">
                        {/* Type badge */}
                        <span className="rt-rd-doc-type-badge">
                            {doc.type === "app" && "General"}
                            {doc.type === "po" && `PO - ${doc.poType === "subcontractor" ? "Subcontractor" : "Recruiter"}`}
                            {doc.type === "req" && (doc.documnetName || "Requested Document")}
                            {doc.type === "esign" && "E-signed"}
                        </span>

                        {/* Date & Time */}
                        <span className="rt-rd-doc-date">
                            <i className="fa fa-calendar" aria-hidden="true" />
                            <Moment format="MMM D, YYYY h:mm a">{doc.date}</Moment>
                        </span>

                        {/* File Size */}
                        {doc.type === "app" && doc.docSize && (
                            <span className="rt-rd-doc-size">
                                <i className="fa fa-hdd-o" aria-hidden="true" /> {doc.docSize}
                            </span>
                        )}
                        {doc.type === "esign" && doc.docSize && (
                            <span className="rt-rd-doc-size">
                                <i className="fa fa-hdd-o" aria-hidden="true" /> {doc.docSize}
                            </span>
                        )}
                        {doc.type === "req" && getReqUploadedSize(doc) && (
                            <span className="rt-rd-doc-size">
                                <i className="fa fa-hdd-o" aria-hidden="true" /> {getReqUploadedSize(doc)}
                            </span>
                        )}
                    </div>
                </div>

                {/* 4. Received Document Preview */}
                <div className="rt-rd-received-preview-col">
                    {doc.type === "req" && (() => {
                        const uploadedDocs = appDocuments.filter(
                            (x) => x.updType === `req_${!doc.id ? doc.docId : doc.id}` && x.deleteFlag !== true
                        );

                        return uploadedDocs.map((d) => (
                            <button
                                key={`received-preview-${d.docId}`}
                                className="rt-rd-received-preview"
                                onClick={() => handleDownloadFile(d)}
                                title="Download Received Document"
                            >
                                <span className="rt-rd-received-preview-title">
                                    <span>{d.docName}</span>
                                    <span className="rt-rd-status-badge is-received">
                                        <i className="fa fa-arrow-down" aria-hidden="true" /> Received
                                    </span>
                                </span>
                                <span className="rt-rd-received-preview-meta">
                                    <span>
                                        <i className="fa fa-calendar" aria-hidden="true" /> <Moment format="MMM D, YYYY h:mm a">{d.dateTime}</Moment>
                                    </span>
                                    {d.docSize && (
                                        <span>
                                            <i className="fa fa-hdd-o" aria-hidden="true" /> {d.docSize}
                                        </span>
                                    )}
                                </span>
                            </button>
                        ));
                    })()}
                </div>

                {/* 3. Notes Popover */}
                {notesContent ? (
                    <div className="rt-rd-notes-col">
                        {getPopover(notesContent)}
                    </div>
                ) : <div className="rt-rd-notes-placeholder" />}

                {/* 5. Sent/Received Badge */}
                <div className="rt-rd-status-col">
                    {doc.type === "app" && (
                        (doc.uploaderType === "WP" || doc.uploaderType === "Super Admin") ? (
                            renderAppDocumentStatusBadge(doc)
                        ) : (
                            <span className="rt-rd-status-badge is-received">
                                <i className="fa fa-arrow-down mr-1" aria-hidden="true" /> Received
                            </span>
                        )
                    )}
                    {doc.type === "po" && (
                        doc.partnerSign ? (
                            <span className="rt-rd-status-badge is-received">
                                <i className="fa fa-arrow-down mr-1" aria-hidden="true" /> Received
                            </span>
                        ) : (
                            <span className="rt-rd-status-badge is-sent">
                                <i className="fa fa-arrow-up mr-1" aria-hidden="true" /> Sent
                            </span>
                        )
                    )}
                    {doc.type === "req" && null}
                    {doc.type === "esign" && (
                        <span className="rt-rd-status-badge is-received">
                            <i className="fa fa-arrow-down mr-1" aria-hidden="true" /> Received
                        </span>
                    )}
                </div>

                {/* 6. Review Status Select Dropdown */}
                <div className="rt-rd-review-col">
                    {doc.type === "app" && (
                        <select
                            className="rt-rd-select-status"
                            value={doc.docStatus}
                            onChange={(e) =>
                                handleDocStatusChange(doc.docId, e.target.value, "doc")
                            }
                        >
                            <option value="">Select Status</option>
                            <option value="1">Approved</option>
                            <option value="0">Not Approved</option>
                        </select>
                    )}
                    {doc.type === "po" && (
                        <select
                            className="rt-rd-select-status"
                            value={doc.status}
                            onChange={(e) =>
                                handleDocStatusChange(doc.id, e.target.value, "po")
                            }
                        >
                            <option value="">Select Status</option>
                            <option value="1">Approved</option>
                            <option value="0">Not Approved</option>
                        </select>
                    )}
                    {doc.type === "req" && (
                        <select
                            className="rt-rd-select-status"
                            value={doc.status}
                            onChange={(e) =>
                                handleDocStatusChange(doc.id, e.target.value, "req")
                            }
                        >
                            <option value="">Select Status</option>
                            <option value="1">Approved</option>
                            <option value="0">Not Approved</option>
                        </select>
                    )}
                    {doc.type === "esign" && (
                        <select
                            className="rt-rd-select-status"
                            value={doc.signedDocStatus}
                            onChange={(e) =>
                                handleDocStatusChange(doc.id, e.target.value, "esign")
                            }
                        >
                            <option value="">Select Status</option>
                            <option value="1">Approved</option>
                            <option value="0">Not Approved</option>
                        </select>
                    )}
                </div>

                {/* 7. Delete Action */}
                <div className="rt-rd-delete-col">
                    {doc.type === "app" && (
                        <button
                            className="rt-rd-delete-btn"
                            title="Delete File"
                            onClick={() => handleDeleteFile(doc.docId, "doc")}
                        >
                            <i className="fa fa-trash"></i>
                        </button>
                    )}
                    {doc.type === "po" && (
                        <button
                            className="rt-rd-delete-btn"
                            title="Delete File"
                            onClick={() => handleDeleteFile(doc.id, "po")}
                        >
                            <i className="fa fa-trash"></i>
                        </button>
                    )}
                    {doc.type === "req" && getReqDeleteAction(doc)}
                    {doc.type === "esign" && (
                        <button
                            className="rt-rd-delete-btn"
                            title="Delete File"
                            onClick={() => handleDeleteFile(doc.id, "esign")}
                        >
                            <i className="fa fa-trash"></i>
                        </button>
                    )}
                </div>
            </div>
        );
    };

    if (sortedDocs.length === 0) {
        return (
            <div className="rt-received-docs-panel">
                <style>{`
                    .rt-received-docs-panel {
                        --rd-primary: #2563eb;
                        --rd-bg-card: #ffffff;
                        --rd-text-dark: #0f172a;
                        --rd-text-muted: #475569;
                        --rd-border: #cbd5e1;
                        --rd-radius: 12px;
                        
                        background: var(--rd-bg-card);
                        border: 1px solid var(--rd-border);
                        border-radius: var(--rd-radius);
                        box-shadow: 0 1px 3px rgba(0,0,0,0.02);
                        padding: 16px;
                        font-family: inherit;
                        font-size: 13px;
                        margin-top: 16px;
                    }
                    .rt-rd-empty {
                        text-align: center;
                        padding: 40px 20px;
                        color: #94a3b8;
                        background-color: #f8fafc;
                        border-radius: 8px;
                        border: 1px dashed #cbd5e1;
                    }
                    .rt-rd-empty i {
                        font-size: 32px;
                        color: #cbd5e1;
                        margin-bottom: 12px;
                        display: block;
                    }
                    .rt-rd-empty-text {
                        font-size: 13px;
                        font-weight: 600;
                    }
                `}</style>
                <div className="rt-rd-empty">
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                    <div className="rt-rd-empty-text">No received documents found.</div>
                </div>
            </div>
        );
    }

    return (
        <div className="rt-received-docs-panel">
            <style>{`
                .rt-received-docs-panel {
                    --rd-primary: #2563eb;
                    --rd-primary-hover: #1d4ed8;
                    --rd-bg-card: #ffffff;
                    --rd-text-dark: #0f172a;
                    --rd-text-muted: #64748b;
                    --rd-border: #cbd5e1;
                    --rd-radius: 12px;
                    
                    font-family: inherit;
                    font-size: 13px;
                    margin-top: 16px;
                }

                .rt-rd-list {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    margin-top: 8px;
                }

                .rt-rd-row {
                    display: grid;
                    grid-template-columns: 36px minmax(0, 1fr) minmax(0, 220px) auto auto auto auto;
                    align-items: center;
                    gap: 8px;
                    background: var(--rd-bg-card);
                    border: 1px solid #dbe3ef;
                    border-radius: 10px;
                    padding: 16px;
                    transition: all 0.15s ease;
                    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
                }

                .rt-rd-row:hover {
                    border-color: #bfdbfe;
                    box-shadow: 0 8px 20px rgba(37, 99, 235, 0.08);
                }

                /* File Icon styling */
                .rt-rd-file-icon {
                    width: 36px;
                    height: 36px;
                    border-radius: 8px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    flex-shrink: 0;
                }

                .rt-rd-file-icon.is-esign {
                    background: rgba(16, 185, 129, 0.08);
                    color: #10b981;
                    border: 1px solid rgba(16, 185, 129, 0.15);
                }

                .rt-rd-file-icon.is-po {
                    background: rgba(99, 102, 241, 0.08);
                    color: #6366f1;
                    border: 1px solid rgba(99, 102, 241, 0.15);
                }

                .rt-rd-file-icon.is-req {
                    background: rgba(245, 158, 11, 0.08);
                    color: #f59e0b;
                    border: 1px solid rgba(245, 158, 11, 0.15);
                }

                .rt-rd-file-icon.is-app {
                    background: rgba(59, 130, 246, 0.08);
                    color: #3b82f6;
                    border: 1px solid rgba(59, 130, 246, 0.15);
                }

                .rt-rd-file-main {
                    min-width: 0;
                }

                .rt-rd-doc-name-btn {
                    background: transparent;
                    border: none;
                    padding: 0;
                    margin: 0;
                    text-align: left;
                    font-size: 13.5px;
                    font-weight: 600;
                    color: var(--rd-primary);
                    cursor: pointer;
                    transition: color 0.15s ease;
                    line-height: 1.3;
                    font-family: inherit;
                }

                .rt-rd-doc-name-btn:hover:not(:disabled) {
                    color: var(--rd-primary-hover);
                    text-decoration: underline;
                }

                .rt-rd-doc-name-btn:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }

                .rt-rd-req-doc-stack {
                    display: flex;
                    flex-direction: column;
                    gap: 3px;
                    align-items: flex-start;
                }

                .rt-rd-req-doc-line {
                    display: grid;
                    grid-template-columns: 32px minmax(0, auto);
                    align-items: center;
                    column-gap: 7px;
                    max-width: 100%;
                }

                .rt-rd-mini-tag {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    min-width: 32px;
                    height: 18px;
                    padding: 0 6px;
                    border-radius: 99px;
                    background: #f8fafc;
                    border: 1px solid #cbd5e1;
                    color: #64748b;
                    font-size: 10px;
                    font-weight: 800;
                    line-height: 1;
                }

                .rt-rd-mini-tag.is-received {
                    background: rgba(16, 185, 129, 0.08);
                    border-color: rgba(16, 185, 129, 0.18);
                    color: #047857;
                }

                .rt-rd-req-doc-link {
                    max-width: 360px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 13px;
                    line-height: 1.2;
                }

                .rt-rd-received-preview-col {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    justify-content: center;
                    gap: 4px;
                    min-width: 0;
                }

                .rt-rd-received-preview {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 4px;
                    max-width: 220px;
                    padding: 0;
                    border: 0;
                    background: transparent;
                    color: var(--rd-primary);
                    cursor: pointer;
                    text-align: left;
                    font-family: inherit;
                }

                .rt-rd-received-preview-title {
                    display: flex;
                    align-items: center;
                    gap: 7px;
                    width: 100%;
                    font-size: 13px;
                    font-weight: 700;
                    line-height: 1.2;
                }

                .rt-rd-received-preview-title span:first-child {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .rt-rd-received-preview-title span.rt-rd-status-badge {
                    flex-shrink: 0;
                    padding: 3px 8px;
                    font-size: 10px;
                    font-weight: 600;
                }

                .rt-rd-received-preview-meta {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    max-width: 100%;
                    padding-left: 0;
                    color: #94a3b8;
                    font-size: 11.5px;
                    line-height: 1.2;
                    white-space: nowrap;
                }

                .rt-rd-received-preview:hover .rt-rd-received-preview-title span:first-child {
                    color: var(--rd-primary-hover);
                    text-decoration: underline;
                }

                .rt-rd-doc-meta {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    margin-top: 4px;
                    flex-wrap: wrap;
                }

                .rt-rd-doc-date {
                    font-size: 12px;
                    color: #94a3b8;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                }

                .rt-rd-doc-size {
                    font-size: 12px;
                    color: #94a3b8;
                    display: flex;
                    align-items: center;
                    gap: 3px;
                }

                .rt-rd-doc-type-badge {
                    font-size: 10px;
                    font-weight: 600;
                    color: #475569;
                    background: #f8fafc;
                    border: 1px solid #cbd5e1;
                    border-radius: 99px;
                    padding: 1px 7px;
                    display: inline-block;
                }

                /* Notes popover trigger styling */
                .rt-rd-notes-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    background: #ffffff;
                    border: 1px solid #cbd5e1;
                    padding: 6px 12px;
                    border-radius: 8px;
                    font-size: 12px;
                    font-weight: 600;
                    color: #475569;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    min-height: 32px;
                }

                .rt-rd-notes-btn:hover {
                    background: #f8fafc;
                    color: #0f172a;
                    border-color: #94a3b8;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                }

                .rt-rd-notes-col {
                }

                .rt-rd-notes-placeholder {
                    width: 0px;
                }

                .rt-rd-status-col {
                }

                .rt-rd-review-col {
                }

                .rt-rd-delete-col {
                }

                /* Badge variants */
                .rt-rd-status-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    padding: 4px 10px;
                    border-radius: 99px;
                    font-size: 12px;
                    font-weight: 700;
                    white-space: nowrap;
                }

                .rt-rd-status-badge.is-received {
                    background: rgba(16, 185, 129, 0.08);
                    color: #047857;
                    border: 1px solid rgba(16, 185, 129, 0.15);
                }

                .rt-rd-status-badge.is-sent {
                    background: rgba(245, 158, 11, 0.1);
                    color: #b45309;
                    border: 1px solid rgba(245, 158, 11, 0.2);
                }

                .rt-rd-status-badge.is-draft {
                    background: rgba(100, 116, 139, 0.08);
                    color: #475569;
                    border: 1px solid rgba(100, 116, 139, 0.18);
                }

                .rt-rd-select-status {
                    font-size: 12px !important;
                    color: #334155 !important;
                    background-color: #ffffff !important;
                    border: 1px solid #cbd5e1 !important;
                    border-radius: 8px !important;
                    padding: 6px 10px !important;
                    outline: none !important;
                    transition: border-color 0.15s ease !important;
                    cursor: pointer !important;
                    min-width: 130px;
                    height: 32px;
                    font-family: inherit !important;
                }

                .rt-rd-select-status:focus {
                    border-color: var(--rd-primary) !important;
                }

                .rt-rd-esign-actions {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    gap: 8px;
                }

                .rt-rd-esign-download-btn {
                    border: 1px solid #cbd5e1;
                    background: #ffffff;
                    color: #334155;
                    border-radius: 8px;
                    min-height: 32px;
                    padding: 6px 10px;
                    font-size: 12px;
                    font-weight: 700;
                    cursor: pointer;
                    transition: all 0.15s ease;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 4px;
                }

                .rt-rd-esign-download-btn:hover {
                    border-color: #94a3b8;
                    background: #f8fafc;
                    color: #0f172a;
                    transform: translateY(-1px);
                }

                .rt-rd-esign-download-btn:disabled {
                    opacity: 0.65;
                    cursor: not-allowed;
                    transform: none;
                }

                .rt-rd-delete-btn {
                    background: rgba(239, 68, 68, 0.06);
                    border: 1px solid rgba(239, 68, 68, 0.18);
                    color: #dc2626;
                    padding: 6px 12px;
                    border-radius: 8px;
                    font-size: 12px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    min-height: 32px;
                }

                .rt-rd-delete-btn:hover {
                    background: rgba(239, 68, 68, 0.12);
                    border-color: rgba(239, 68, 68, 0.28);
                    color: #b91c1c;
                    transform: translateY(-1px);
                }

                /* Popover custom styling to match Documents */
                .popover {
                    border-radius: 8px !important;
                    border: 1px solid #cbd5e1 !important;
                    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
                    font-family: inherit !important;
                    overflow: hidden;
                }
                .popover-header, .popover-title {
                    background: #f8fafc !important;
                    border-bottom: 1px solid #e2e8f0 !important;
                    font-size: 13px !important;
                    font-weight: 700 !important;
                    color: #0f172a !important;
                    padding: 10px 14px !important;
                }
                .popover-body, .popover-content {
                    padding: 12px 14px !important;
                    font-size: 13px !important;
                    color: #334155 !important;
                    line-height: 1.55 !important;
                }
            `}</style>
            <div className="rt-rd-list">
                {sortedDocs.map((doc, key) => (
                    <React.Fragment key={key}>
                        {renderCard(doc)}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default ReceivedDocuments;
